import { render } from "./SettingsTabPayoutCreate.vue?vue&type=template&id=4aadbbca"
import script from "./SettingsTabPayoutCreate.vue?vue&type=script&lang=js"
export * from "./SettingsTabPayoutCreate.vue?vue&type=script&lang=js"

import "./SettingsTabPayoutCreate.vue?vue&type=style&index=0&id=4aadbbca&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__